// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell,
.headerCell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  padding: 0 0.5em;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(170, 170, 170, 0.25);
}
.headerCell {
  font-weight: bold;
}

.cell.editable:hover {
  background: lightblue;
}

.resized,
.active-resize div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.rotate-header {
  transform: rotate(-90deg);
}

.active-resize {
  background-color: white;
  z-index: 20;
  position: fixed !important;
}

.cell.in-range,
.cell.in-range.editable:hover,
.headerCell.in-range {
  background: lightgrey;
  border-style: dashed;
  border-color: darkgrey;
}

.headerCell {
  align-items: center;
  text-align: center;
}

.headerCell.selected {
  background: black;
  color: white;
}

.headerCell div.text-nowrap div {
  display: inline;
}

html,
body,
.container-fluid,
#content {
  height: 100%;
  width: 100%;
  padding-top: 0 !important;
}

.container-fluid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.crossed {
  height: 100%;
  width: 100%;
  position: relative;
  background: linear-gradient(
    to top right,
    rgba(170, 170, 170, 0) 0%,
    rgba(170, 170, 170, 0) calc(50% - 2px),
    rgba(170, 170, 170, 1) 50%,
    rgba(170, 170, 170, 0) calc(50% + 2px),
    rgba(170, 170, 170, 0) 100%
  );
}

.grid-menu {
  width: 50%;
  height: 50%;
  border-bottom: 2px solid rgb(170, 170, 170);
  border-right: 2px solid rgb(170, 170, 170);
  text-align: center;
}
.grid-menu:active,
.grid-menu.open {
  background: black;
  color: white;
}
.grid-menu span {
  font-size: 20px;
  line-height: 20px;
}
.grid-menu .bouncer {
  margin: auto;
  height: 10px;
  width: 10px;
}
.grid-menu .double-bounce1,
.grid-menu .double-bounce2 {
  margin-top: 3px;
}
.rows {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 10px;
  font-weight: bold;
  padding-left: 3px;
}
.cols {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
  font-weight: bold;
  padding-right: 4px;
}
.DragHandle {
  flex: 0 0 16px;
  z-index: 2;
  cursor: col-resize;
  color: #0085ff;
  right: 0;
  position: absolute;
}
.DragHandle:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.DragHandleActive,
.DragHandleActive:hover {
  color: #0b6fcc;
  z-index: 3;
}

.DragHandleIcon {
  flex: 0 0 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.is-pinned .main-grid {
  width: calc(100vw - 15.2em) !important;
}

.cell > html-cell {
  height: inherit;
  width: 100%;
}

.cell > html-cell img {
  height: inherit;
  width: inherit;
}

.cell img:hover {
  position: fixed;
  width: 500px !important;
  height: auto !important;
  display: block;
  z-index: 999;
  border-radius: 0.25rem;
  border: 1px solid #a7b3b7;
}

.editor-select .Select--single {
  min-width: inherit;
  width: inherit;
  height: inherit;
}

.editor-select .Select__control {
  height: inherit;
}

.editor-select .Select__value-container {
  padding: 0;
}

.editor-select .Select__indicator {
  padding-top: 0;
  padding-bottom: 0;
}

.editor-select .Select__indicators {
  height: inherit;
}

.editor-select .Select__control .Select__single-value {
  right: unset;
  padding-left: 0;
}
`, "",{"version":3,"sources":["webpack://./static/dtale/DataViewer.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;EAGE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB;;;;;;;GAOC;AACH;;AAEA;EACE,UAAU;EACV,WAAW;EACX,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".cell,\n.headerCell {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: right;\n  padding: 0 0.5em;\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgba(170, 170, 170, 0.25);\n}\n.headerCell {\n  font-weight: bold;\n}\n\n.cell.editable:hover {\n  background: lightblue;\n}\n\n.resized,\n.active-resize div {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.rotate-header {\n  transform: rotate(-90deg);\n}\n\n.active-resize {\n  background-color: white;\n  z-index: 20;\n  position: fixed !important;\n}\n\n.cell.in-range,\n.cell.in-range.editable:hover,\n.headerCell.in-range {\n  background: lightgrey;\n  border-style: dashed;\n  border-color: darkgrey;\n}\n\n.headerCell {\n  align-items: center;\n  text-align: center;\n}\n\n.headerCell.selected {\n  background: black;\n  color: white;\n}\n\n.headerCell div.text-nowrap div {\n  display: inline;\n}\n\nhtml,\nbody,\n.container-fluid,\n#content {\n  height: 100%;\n  width: 100%;\n  padding-top: 0 !important;\n}\n\n.container-fluid {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.crossed {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: linear-gradient(\n    to top right,\n    rgba(170, 170, 170, 0) 0%,\n    rgba(170, 170, 170, 0) calc(50% - 2px),\n    rgba(170, 170, 170, 1) 50%,\n    rgba(170, 170, 170, 0) calc(50% + 2px),\n    rgba(170, 170, 170, 0) 100%\n  );\n}\n\n.grid-menu {\n  width: 50%;\n  height: 50%;\n  border-bottom: 2px solid rgb(170, 170, 170);\n  border-right: 2px solid rgb(170, 170, 170);\n  text-align: center;\n}\n.grid-menu:active,\n.grid-menu.open {\n  background: black;\n  color: white;\n}\n.grid-menu span {\n  font-size: 20px;\n  line-height: 20px;\n}\n.grid-menu .bouncer {\n  margin: auto;\n  height: 10px;\n  width: 10px;\n}\n.grid-menu .double-bounce1,\n.grid-menu .double-bounce2 {\n  margin-top: 3px;\n}\n.rows {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  font-size: 10px;\n  font-weight: bold;\n  padding-left: 3px;\n}\n.cols {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 10px;\n  font-weight: bold;\n  padding-right: 4px;\n}\n.DragHandle {\n  flex: 0 0 16px;\n  z-index: 2;\n  cursor: col-resize;\n  color: #0085ff;\n  right: 0;\n  position: absolute;\n}\n.DragHandle:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.DragHandleActive,\n.DragHandleActive:hover {\n  color: #0b6fcc;\n  z-index: 3;\n}\n\n.DragHandleIcon {\n  flex: 0 0 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.is-pinned .main-grid {\n  width: calc(100vw - 15.2em) !important;\n}\n\n.cell > html-cell {\n  height: inherit;\n  width: 100%;\n}\n\n.cell > html-cell img {\n  height: inherit;\n  width: inherit;\n}\n\n.cell img:hover {\n  position: fixed;\n  width: 500px !important;\n  height: auto !important;\n  display: block;\n  z-index: 999;\n  border-radius: 0.25rem;\n  border: 1px solid #a7b3b7;\n}\n\n.editor-select .Select--single {\n  min-width: inherit;\n  width: inherit;\n  height: inherit;\n}\n\n.editor-select .Select__control {\n  height: inherit;\n}\n\n.editor-select .Select__value-container {\n  padding: 0;\n}\n\n.editor-select .Select__indicator {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.editor-select .Select__indicators {\n  height: inherit;\n}\n\n.editor-select .Select__control .Select__single-value {\n  right: unset;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
